import { VList } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import HubSection from './HubSection/HubSection'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({
  spacing: [1.75, LAYOUT_SPACING.X_LARGE],
  'data-cy': `hub-sections-list`,
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubSectionsList = ({ sections }) => (
  <Layout>
    {renderList(
      (section) => (
        <HubSection {...section} />
      ),
      sections
    )}
  </Layout>
)

HubSectionsList.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default HubSectionsList
